import React from "react";
import "./Policy.css";

const RefundCancellation = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">

        <h1>Refund & Cancellation Policy</h1>

        <h2>Order Cancellation</h2>

        <p>
          Orders can be cancelled before they are shipped.
          Once an order is dispatched, cancellation may not be possible.
        </p>

        <h2>Refund Eligibility</h2>

        <ul>
          <li>Product damaged during shipping</li>
          <li>Wrong product delivered</li>
          <li>Manufacturing defect</li>
        </ul>

        <h2>Refund Process</h2>

        <p>
          After inspection, approved refunds will be processed
          within 5–7 business days.
        </p>

        <h2>Non-Refundable Items</h2>

        <ul>
          <li>Used products</li>
          <li>Products damaged by misuse</li>
        </ul>

      </div>
    </div>
  );
};

export default RefundCancellation;